import { Configuration, UsersApi } from "../../generated-client";
import "reflect-metadata";

export class UserClient {
	public usersApi: UsersApi;

	constructor() {
		const basePath =
			window.BACKEND_URL || location.origin || "http://localhost:3000";
		const config = new Configuration({
			basePath: basePath,
			accessToken: () => sessionStorage.getItem("jwt") || "",
		});
		this.usersApi = new UsersApi(config);
	}
}
